// Unlock fees for Cars and Houses for Sale are based on the listing's price,
// unlike Rentals (by bedroom type) and Land (flat fee). These functions are
// the single source of truth for that pricing — used both when a lister
// submits/edits a listing (to compute what gets stored) and can be reused
// anywhere else the fee needs to be shown or recalculated.
//
// Boundary rule: the fee for a price band applies up to AND INCLUDING that
// band's top number (e.g. a car priced at exactly 1,500,000 gets 150, not 250).

export const getCarUnlockFee = (price: number): number => {
  if (price <= 1_500_000) return 150;
  if (price <= 2_500_000) return 250;
  if (price <= 3_500_000) return 350;
  if (price <= 4_500_000) return 450;
  if (price <= 6_000_000) return 550;
  return 650; // above 6M — continuing the same +100 step; adjust here if a different top-tier rate is wanted
};

export const getHouseUnlockFee = (price: number): number => {
  if (price <= 5_000_000) return 200;
  if (price <= 10_000_000) return 450;
  if (price <= 15_000_000) return 550;
  return 1000;
};
